import { render, staticRenderFns } from "./AppShell.vue?vue&type=template&id=57fae4b4&"
import script from "./AppShell.vue?vue&type=script&lang=js&"
export * from "./AppShell.vue?vue&type=script&lang=js&"
import style0 from "./AppShell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports